// src/components/NotificationSettings.js
import React, { useCallback } from 'react';
import { getFcmToken } from '../services/firebaseService'; // Import getFcmToken

function NotificationSettings({
    showNotificationsModal,
    setShowNotificationsModal,
    isNotificationsEnabled,
    browserNotificationPermission,
    wsRef,
    deviceId,
    fcmToken,
    setProcessMessage,
    setIsNotificationsEnabled,
    setBrowserNotificationPermission,
    setFcmToken,
    messageTimeoutId
}) {

    const handleToggleServerNotifications = useCallback(async (enable) => {
        if (wsRef.current && wsRef.current.readyState === WebSocket.OPEN) {
            const action = enable ? 'enable_notifications' : 'disable_notifications';
            const message = { action: action, deviceid: deviceId };

            if (enable && !fcmToken) {
                setProcessMessage('Attempting to get FCM token before enabling notifications...');
                const token = await getFcmToken(setProcessMessage, setFcmToken, setBrowserNotificationPermission); // Pass setters
                if (token && wsRef.current && wsRef.current.readyState === WebSocket.OPEN) {
                    message.fcm = token;
                    wsRef.current.send(JSON.stringify(message));
                    setProcessMessage('✅ Notifications enabled on server with new token.');
                } else if (!token) {
                    setProcessMessage('❌ Failed to get FCM token. Cannot enable notifications.');
                }
            } else if (enable && fcmToken) {
                message.fcm = fcmToken;
                wsRef.current.send(JSON.stringify(message));
                setProcessMessage(`Requesting to ${enable ? 'enable' : 'disable'} notifications on server.`);
            } else { // Disabling notifications, no token needed
                wsRef.current.send(JSON.stringify(message));
                setProcessMessage(`Requesting to ${enable ? 'enable' : 'disable'} notifications on server.`);
            }

            if (messageTimeoutId.current) {
                clearTimeout(messageTimeoutId.current);
            }
            messageTimeoutId.current = setTimeout(() => {
                setProcessMessage('');
            }, 3000);
        } else {
            setProcessMessage('WebSocket not connected. Cannot change notification status.');
        }
        setShowNotificationsModal(false);
    }, [wsRef, deviceId, fcmToken, setProcessMessage, setShowNotificationsModal, setFcmToken, setBrowserNotificationPermission, messageTimeoutId]);


    return (
        <>
            {showNotificationsModal && browserNotificationPermission === 'granted' && (
                <div style={{
                    position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.5)',
                    display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 2000
                }}>
                    <div style={{
                        backgroundColor: 'white', padding: '20px', borderRadius: '8px', boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
                        width: '90%', maxWidth: '400px', textAlign: 'center'
                    }}>
                        <h2>Notification Settings</h2>
                        <p>
                            Notifications are currently **{isNotificationsEnabled ? 'Enabled' : 'Disabled'}** on the server.
                        </p>
                        {isNotificationsEnabled ? (
                            <button
                                onClick={() => handleToggleServerNotifications(false)}
                                style={{
                                    padding: '10px 20px', backgroundColor: '#dc3545', color: 'white', border: 'none',
                                    borderRadius: '5px', cursor: 'pointer', marginRight: '10px'
                                }}
                            >
                                Disable Notifications
                            </button>
                        ) : (
                            <button
                                onClick={() => handleToggleServerNotifications(true)}
                                style={{
                                    padding: '10px 20px', backgroundColor: '#28a745', color: 'white', border: 'none',
                                    borderRadius: '5px', cursor: 'pointer', marginRight: '10px'
                                }}
                            >
                                Enable Notifications
                            </button>
                        )}
                        <button
                            onClick={() => setShowNotificationsModal(false)}
                            style={{
                                padding: '10px 20px', backgroundColor: '#6c757d', color: 'white', border: 'none',
                                borderRadius: '5px', cursor: 'pointer'
                            }}
                        >
                            Close
                        </button>
                    </div>
                </div>
            )}
        </>
    );
}

export default NotificationSettings;